import { config } from '../config';

export function log(...args: unknown[]) {
  if (config.isDev) {
    // eslint-disable-next-line no-console
    console.log('[SignatureApp]', ...args);
  }
}

export function logError(...args: unknown[]) {
  // eslint-disable-next-line no-console
  console.error('[SignatureApp]', ...args);
}

/** Never log full access tokens. */
export function redactToken(token: string): string {
  if (!token) return '(empty)';
  if (token.length < 16) return '(short)';
  return `${token.slice(0, 8)}…${token.slice(-4)} (len=${token.length})`;
}
